import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import selectstyle from './input.module.scss'


const ERCSelect = ({ name, onChange, options, selectClass, placeholder, width }) => {

    const theme = (theme) => ({
        ...theme,
        borderRadius: 12,
        // fontFamily: 'Manrope',
        spacing: {
            ...theme.spacing,
            controlHeight: 30,
            baseUnit: 0,
        },
    });

    const styles = {
        control: (base) => ({
            ...base,
            width: width || '100%',
            paddingLeft: "20px",
            border: '2px solid #E2E8F0',
            // borderColor: '#FFD600',
            boxShadow: 'none !important',
            "&:hover": {
                borderColor: "#FFD600",
                color: "#FFD600",
            },
            "&:focus-within": {
                borderColor: "#FFD600"
            },
            
        }),
        indicatorSeparator: (base) => ({
            ...base,
            display: 'none',
        }),
    }

    const [value, setValue] = useState('')
    useEffect(() => {

        onChange(value)
    }, [value, onChange])
    return (
        <div className={selectstyle.container}>
            <input  type="hidden" name={name} value={value.value} />
            <Select styles={styles} placeholder={placeholder} theme={theme} classNamePrefix={`${selectClass} pl-[1px] text-[14px] hover:!border-yellow-300 border-[#FFD600]`} options={options} onChange={setValue} width="300px" />
        </div>
    )
}
export default ERCSelect